module.exports = __webpack_public_path__ + "static/media/volley.0416bd34.png";